import $ from "jquery";
import { sitemap, category, article } from "#templates/pages/sitemap/sitemap_template";
import { AimError } from "#scripts/tools/aimlog.js";
import { getLangForApi } from "#scripts/cmsapi.js";
import language from "#scripts/translation";
import { getStoredNav } from "#scripts/nav.js";

export const sitemappage = () => {
	(async () => {
		try {
			// await waitForNavData(10000, 100); // wait up to 10 sec, check every 100 ms
			const navdata = getStoredNav();
			const allArticlesPromises = traverseSite(navdata);
			await Promise.all(allArticlesPromises);
			document.getElementById("sitemap").innerHTML = buildSiteMap(navdata);
		} catch (err) {
			console.error(err);
			document.getElementById("sitemap").innerHTML = `<p>Kunne ikke laste Nettstedkart</p>`;
		}
	})();

	return `
        <section class="breadcrumbs">
          <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="fullnav__breadcrumb__container">
                        <nav aria-label="breadcrumb">
                            <ol class="aim-breadcrumb fullnav__breadcrumb" id="full__breadcrumb">
                            <li class="aim-breadcrumb-item"><a href="/">${language("NAV_FRONTPAGE")}</a></li>
                            <li class="aim-breadcrumb-item active" aria-current="page" id="currentPageBreadcrumb">${language("NAV_SITEMAP")}</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
        </section>
        <section class="sitemap__section">
            <div class="container">
                <div class="row ">
                    <div class="col-md-12">
                        <div class="sitemap__content">
                            <h1 class="page__header">${language("NAV_SITEMAP")}</h1>
														<div id="sitemap">
															<div class="row">
																	<div class="col-sm-12 pt-5 text-center">
																			<div class="spinner-border" role="status">
																				<span class="sr-only">Loading...</span>
																			</div>
																	</div>
															</div>
														</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    `;
};

const traverseSite = (navs) => {
	let allArticlesPromises = [];
	for (const nav of navs) {
		const articlesPromise = getArticlesForCategory(nav.categoryId)
			.then((allArticles) => {
				nav._articles = allArticles;
			})
			.catch((error) => {
				console.log("Error:", error);
			});

		allArticlesPromises.push(articlesPromise);

		if (nav.children?.length > 0) {
			const childArticlesPromise = traverseSite(nav.children);
			allArticlesPromises = allArticlesPromises.concat(childArticlesPromise);
		}
	}
	return allArticlesPromises;
};

const buildSiteMap = (navs, _level = 0) => {
	const level = _level + 1;
	let htmlString = "";

	for (const nav of navs) {
		if (nav.previewItem.charAt(0) !== "_") {
			htmlString += category({
				item: nav,
				level,
			});
		}
		nav._articles = nav._articles.listOfContent;
		for (const a of nav._articles) {
			const shouldDisplay = a.contentTypeGuid !== "17c15981-758d-4d09-a7ee-b2d47d2af6f0"; // forsidebilde
			if (shouldDisplay) {
				htmlString += article({
					item: a,
					level,
				});
			}
		}
		if (nav.children?.length > 0) {
			htmlString += buildSiteMap(nav.children, level);
		}
	}
	return htmlString;
};

const getArticlesForCategory = (category) => {
	const config = JSON.parse(sessionStorage.getItem("config"));

	const senddata = JSON.stringify({
		categoryId: category,
		subscriptionId: config.clientId,
	});

	const settings = {
		type: "GET",
	};
	const apiCall = `${window.apiUrl}/Public/articles?subscriptionId=${
		config.clientId
	}&category=${category}&language=${getLangForApi()}&limit=1000&getRecursiveContent=true&sortBy=Title&LanguageMode=Strict`;

	return $.ajax(apiCall, settings)
		.done((data) => data)
		.catch((error) => {
			console.error("Error:", error);
			// AimError('API Error: ' + error.toString(), window.apiUrl + '/PublicContentApi/getbycategoryidasstring');
			AimError(`API Error: ${error.toString()}`, `${window.apiUrl}/Public/articles`);
		});
};
